import Vue from 'vue'
import Vuex from 'vuex'
import usuarioModulo from '@/store/usuario'
import carritoModulo from '@/store/carrito'
import productosModulo from '@/store/productos'
import i18n from '@/main'
import es from '@/assets/co.png'
import en from '@/assets/us.png'
import paises from '@/store/paises.json'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    usuarioModulo,
    carritoModulo,
    productosModulo
  },
  state: {
    pwa: null,
    activador: null,
    mostrado: false,
    cargado: false,
    porcentajeCarga: 0,
    comision: '',
    dolar: null,
    cargandoAccion: false,
    loading: false,
    idioma: 'en',
    moneda: 'COP',
    newsletter: false,
    paises,
    idiomas: [
      {
        id: 'es',
        src: es,
        titulo: 'Español'
      },
      {
        id: 'en',
        src: en,
        titulo: 'English'
      }
    ],
    monedas: [
      {
        id: 'COP',
        src: es,
        titulo: 'Pesos Colombianos'
      },
      {
        id: 'USD',
        src: en,
        titulo: 'US Dollars'
      }
    ],
    tipoRedes: [
      {
        nombre: 'Instagram',
        icono: 'fab fa-instagram'
      },
      {
        nombre: 'Facebook',
        icono: 'fab fa-facebook-square'
      },
      {
        nombre: 'Twitter',
        icono: 'fab fa-twitter-square'
      },
      {
        nombre: 'Youtube',
        icono: 'fab fa-youtube-square'
      },
      {
        nombre: 'LinkedIn',
        icono: 'fab fa-linkedin'
      }
      /* {
        nombre: 'Behance',
        icono: 'fab fa-behance'
      },
      {
        nombre: 'Pinterest',
        icono: 'fab fa-pinterest-square'
      },
      {
        nombre: 'Tumblr',
        icono: 'fab fa-tumblr-square'
      },
      {
        nombre: 'Vimeo',
        icono: 'fab fa-vimeo'
      },
      {
        nombre: 'Snapchat',
        icono: 'fab fa-snapchat-square'
      },
      {
        nombre: 'LinkedIn',
        icono: 'fab fa-linkedin'
      },
      {
        nombre: 'Web',
        icono: 'fas fa-globe'
      } */
    ],
    alerta: false,
    textoAlerta: '',
    dialog: {
      activate: false,
      message: ''
    },
    articulos: []
  },
  getters: {
    getPwa: (state) => {
      return state.pwa
    },
    getActivador: (state) => {
      return state.activador
    },
    getMostrado: (state) => {
      return state.mostrado
    },
    getNewsletter: (state) => {
      return state.newsletter
    },
    getDolar: (state) => {
      return state.dolar
    },
    getComision: (state) => {
      return state.comision
    },
    getPorcentajeCarga: (state) => {
      return state.porcentajeCarga
    },
    getArticulos: (state) => {
      return state.articulos
    },
    getCargado: (state) => {
      return state.cargado
    },
    getCargandoAccion: (state) => {
      return state.cargandoAccion
    },
    getLoading: (state) => {
      return state.loading
    },
    getIdioma: (state) => {
      return state.idioma
    },
    getMoneda: (state) => {
      return state.moneda
    },
    getIdiomas: (state) => {
      return state.idiomas
    },
    getMonedas: (state) => {
      return state.monedas
    },
    getAlerta (state) {
      return state.alerta
    },
    getTextoAlerta (state) {
      return state.textoAlerta
    },
    getDialog: (state) => {
      return state.dialog
    },
    getPaises: (state) => {
      return state.paises
    },
    getTipoRedes: (state) => {
      return state.tipoRedes
    }
  },
  mutations: {
    setActivador: (state, valor) => {
      state.activador = valor
    },
    setMostrado: (state, valor) => {
      state.mostrado = valor
    },
    setNewsletter: (state, newsletter) => {
      state.newsletter = newsletter
    },
    setDolar: (state, dolar) => {
      state.dolar = dolar
    },
    setComision: (state, comision) => {
      state.comision = comision
    },
    setPorcentajeCarga: (state, porcentaje) => {
      state.porcentajeCarga = state.porcentajeCarga + porcentaje
    },
    setArticulos: (state, articulos) => {
      state.articulos = articulos
    },
    eliminarArticulo: (state, uid) => {
      for (let i = 0; i < state.articulos.length; i++) {
        if (state.articulos[i].uid === uid) {
          state.articulos.splice(i, 1)
        }
      }
    },
    setCargado: (state, estado) => {
      state.cargado = estado
    },
    setCargandoAccion: (state, estado) => {
      state.cargandoAccion = estado
    },
    setLoading: (state, estado) => {
      state.loading = estado
    },
    setIdioma: (state, idioma) => {
      state.idioma = idioma
      i18n.locale = idioma
    },
    setMoneda: (state, moneda) => {
      state.moneda = moneda
    },
    setAlerta (state) {
      state.alerta = !state.alerta
    },
    setTextoAlerta (state, textoAlerta) {
      state.textoAlerta = textoAlerta
    },
    setDialog (state, dialog) {
      state.dialog = dialog
    },
    setPwa (state, info) {
      state.pwa = info
    },
    activarPwa (state) {
      state.pwa.prompt()
      // state.pwa.userChoice.then((choiceResult) => {
      //   if (choiceResult.outcome === 'accepted') {
      //     console.log('El usuario aceptó la instalación')
      //   } else {
      //     console.log('El usuario rechazó la instalación')
      //   }
      // })
    }
  },
  actions: {
    addDialog: ({ commit }, text) => {
      let obj = {
        activate: true,
        message: text
      }
      // console.log(obj)
      commit('setDialog', obj)
    },
    enviarCorreo: ({ commit }, info) => {
      axios({
        method: 'post',
        url: '/enviarcorreo',
        crossDomain: true,
        data: {
          destino: info.destino,
          asunto: info.asunto,
          texto: info.texto,
          filename: info.filename
        }
      })
        .then(response => {
          commit('setAlerta')
          commit('setTextoAlerta', 'Alerta.CorreoEnviado')
        })
        .catch(error => {
          console.log('Enviar correo Error')
          commit('setAlerta')
          commit('setTextoAlerta', error)
        })
    },
    enviarCorreoAdjunto: ({ commit }, info) => {
      axios({
        method: 'post',
        url: '/enviarcorreoAdjunto',
        crossDomain: true,
        data: {
          destino: info.destino,
          asunto: info.asunto,
          texto: info.texto,
          filename: info.filename,
          path: info.path
        }
      })
        .then(response => {
          commit('setAlerta')
          commit('setTextoAlerta', 'Alerta.CorreoEnviado')
        })
        .catch(error => {
          // console.log('Enviar correo Error')
          commit('setAlerta')
          commit('setTextoAlerta', error)
        })
    }
  }
})
